module.exports = __webpack_public_path__ + "static/media/merchantProfile.2dc3bf2a.svg";